import {dev} from "./environment.dev";
import {stage} from "./environment.stage";
import {prod} from "./environment.prod";
import {local} from "./environment.local";

export const Local = local; 
export const Dev = dev;
export const Stage = stage;
export const Prod = prod;
